//
// Wrap Tables in Akkordeon RTE
//

let akkordeonContent = document.querySelectorAll('.akkordeon-content');

if (typeof (akkordeonContent) != 'undefined' && akkordeonContent != null) {

    for ( var i=0 ; i < akkordeonContent.length; i++) {
        let tableCount = akkordeonContent[i].querySelectorAll('table');

        let getTables = [].slice.call(tableCount);

        getTables.forEach(function(table){
            let tableWrapper = document.createElement('div');

            tableWrapper.classList.add('table-wrapper');

            table.parentNode.insertBefore(tableWrapper, table);

            tableWrapper.appendChild(table);
        });
    }

}

export default {};